import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/carotis_us.jpg"

const Carotis = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - Carotis Ultraschall </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Bei einer Ultraschalluntersuchung der Arteria Carotis ( Halsschlagader ) wird untersucht, ob Verkalkungen (Plaques) vorliegen, und ob es dadurch zu Verengungen (Stenosen) kommt. Risikofaktoren sind Nikotinkonsum, Bluthochdruck, Übergewicht bzw. Fettstoffwechselstörungen (Cholesterin), Diabetes mellitus. Dadurch besteht ein erhöhtes Risiko für Schlaganfall (Insult).
                        <br />  <br />
                        Die Untersuchung hat keinerlei Nebenwirkungen und beinhaltet auch keine Strahlenbelastung.
                        <br />
                        Die Untersuchung dauert ca. 15 - 20 min und benötigt keine Vorbereitung.
                        <b> Wann führen wir eine Ultraschalluntersuchung durch? </b>
                        <ul>
                            <li>Anfälle von Bewusstlosigkeit (Synkopen), wiederholte Stürze</li>
                            <li>Verdacht auf Schlaganfall bzw. "Vorboten" (TIA) eines Schlaganfalls</li>
                            <li>Schwindel</li>
                            <li>Nachweis für Arteriosklerose (Gefäßverkalkungen)</li>
                            <li>Routinemäßig bei Risikopatienten für Rauchen, Diabetes mellitus, Übergewicht, positive Familienanamnese</li>
                            <li>Präoperativ</li>
                        </ul>
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Carotis;